import type { MediaTemplateType } from './types';
import { uploadCampaignMediaUrl } from './urls';

import { HsmBackendHttpClient, HsmBackendResponse } from '@/utils/http-client';

interface UploadCampaignMediaParams {
  websiteId: string;
  templateType: MediaTemplateType;
  file: File;
}

export async function uploadCampaignMedia({
  websiteId,
  templateType,
  file,
}: UploadCampaignMediaParams): Promise<string> {
  const client = HsmBackendHttpClient.instance;

  if (!['IMAGE', 'VIDEO', 'DOCUMENT'].includes(templateType)) {
    throw new Error('Template type is not Multimedia');
  }

  const formData = new FormData();

  formData.append('file', file);
  formData.append('templateType', templateType);

  const url = uploadCampaignMediaUrl(websiteId);
  const mediaFileResponse = await client.postFormData<
    HsmBackendResponse<{ mediaUrl: string }>
  >(url, formData);

  return mediaFileResponse.result.mediaUrl;
}
